export const FMA_MARKETING_CHANNEL = 'fma_marketing';
export function isPwaChannel(channel) {
    return channel === 'pwa_marketing' || channel === 'pwa_practice';
}
